import React from 'react';
import { Link } from "react-router-dom";
import { Grid, Box, Typography } from "@mui/material";
import StorageIntegrationWizard from './StorageIntegrationWizard';
import DeliveryInfo from '../../organization_dashboard/DeliveryInfo';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const DeliveryConfig = ({ value, index, organization }) => {
    return (
        <TabPanel value={value} index={index}>
            <DeliveryInfo
                organization={organization}
                organizationId={organization?._id}
                s3Config={organization?.s3_config}
                deliveryFormat={organization?.delivery_format}
            />
        </TabPanel>
    );
};

export default DeliveryConfig;
